<form @submit.prevent="onSubmit" class="kl-search-invoices vl-form" v-kl-u-background-alt v-kl-u-box-padding>
    <vl-form-grid mod-stacked>
        <vl-column width-l="7">
            <label for="document-reference">Doc nr</label>
            <vl-input-field name="documentReference" id="document-reference" placeholder="Zoek trefwoord" autocomplete="off"
                v-model="documentReference" mod-block />
        </vl-column>
        <vl-column width-l="5">
            <vl-form-grid mod-stacked>
                <vl-column width="half" width-xs="12">
                    <kl-field-validation-wrapper-yup for="date-from" :field="fields.dateFrom"
                                                     v-slot="{hasErrors}" mod-required mod-hidden-label>
                        <label for="date-from">Van</label>
                        <kl-datepicker v-model="dateFrom" id="date-from" :max-date="dateFromMaxDate" />
                    </kl-field-validation-wrapper-yup>
                </vl-column>
                <vl-column width="half" width-xs="12">
                    <kl-field-validation-wrapper-yup for="date-from" :field="fields.dateTo"
                                                     v-slot="{hasErrors}" mod-required mod-hidden-label>
                        <label for="date-to">Tot en met</label>
                        <kl-datepicker v-model="dateTo" id="date-to" :min-date="dateToMinDate" />
                    </kl-field-validation-wrapper-yup>
                </vl-column>
            </vl-form-grid>
        </vl-column>
        <vl-column v-vl-visually-hidden>
            <vl-action-group>
                <vl-button type="submit" v-vl-visually-hidden>Zoeken</vl-button>
            </vl-action-group>
        </vl-column>
    </vl-form-grid>
</form>
